import React from 'react';
import { Image } from 'antd';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';
import { FarmData } from 'types/FarmData';
import { FarmGaleriesWrapper } from './style';

interface Props {
  farm: FarmData | undefined;
}

const Galeries: React.FC<Props> = ({ farm }) => {
  const { PreviewGroup } = Image;

  return (
    <FarmGaleriesWrapper>
      <PreviewGroup>
        {farm?.images.map((galery, index) => (
          <FallbackImage
            key={index}
            src={galery.url_original ?? ''}
            type={'FarmGalery'}
            className={'farm-gallery-image-container'}
            preview={true}
          />
        ))}
      </PreviewGroup>
    </FarmGaleriesWrapper>
  );
};

export default Galeries;
